export enum LayerId {
  Chart = "chart",
  Labels = "labels"
}
